import { communicationLogService } from '../../helpers/services/communicationLog.service'
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: {
    data: [],
    pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 },
  },
  status: { list: true },
}

export const COMMUNICATION_LOG_MODULE = 'communicationLog'

export const GET_ALL_COMMUNICATION_LOGS = 'getAllCommunicationLogs'
export const RESEND_COMMUNICATION_LOG = 'resendCommunicationLog'

const REQUESTING = 'requesting'
const ALL_SUCCESS = 'allSuccess'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'

function mapRow(item) {
  return {
    id: item.id,
    userName: item.user?.name || '—',
    userEmail: item.user?.email || '',
    to: item.to,
    method: item.method,
    methodId: item.method_id,
    purpose: item.purpose,
    isUsed: !!item.is_used,
    isPaid: !!item.is_paid,
    isInternalUser: !!item.is_itechventis_user,
    createdAt: filtersHelper.getDateTimeFormat(item.created_at),
  }
}

export const actions = {
  [GET_ALL_COMMUNICATION_LOGS]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    return communicationLogService
      .getAllCommunicationLogs(filter)
      .then((result) => {
        commit(ALL_SUCCESS, { data: result })
        commit(SUCCESS)
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [RESEND_COMMUNICATION_LOG]({ commit, dispatch }, { id, filter }) {
    return communicationLogService
      .resendCommunicationLog(id)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('message.resendXSuccess', [i18n.t('label.email')]))
        commit(SUCCESS)
        if (filter) dispatch(GET_ALL_COMMUNICATION_LOGS, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
}

export const mutations = {
  [ALL_SUCCESS](state, { data }) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [FAILURE](state) { state.status = { list: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true } },
}
